import { EpimsBaseEntityDto } from './epim-base.dto';
export class ObligationPaymentHistoryDto extends EpimsBaseEntityDto {

   OwnerType: string;
     ObligationPeriod: string;
     TotalAcreage: number
     Unit: string;
     TotalAmount: number
     UomRate: number
     Description: string;
     CreatedBy: string;
     LandCode: string;
     SubscriptionUserId: string;
     Status: string;
     LandTitleId: string;
     ReminderDays: string;
     ReminderEmail: string;
     Remarks: string;
     Years: string;
     Days: string;
     Rate: string;
     TerrainId: string;
     ApprovalStatus: string;
     PaymentStatus: string;
     LessorsId: string;
     Currency: string;
     LessorInfo_LesssorId: string;
     ReminderPhone: string;
     LastCallDate: Date;
     NextCallDate: Date;
     EndCallDate: Date;
     FirstCallDate: Date;
     LandType: string;
     Area: string;
     UOM: string;
     LandUom: string;
     Terrain: string;
     Amount: number;
     ObligationMasterTrackId: string;
     date: Date;
     FacilityID: string;
     FacilityName: string;
     CompanyRate: string;
     GovtRate: string;
     BulkPaymentHistoryId: string;
     AgreedRate: string;
     BulkPaymentTrackId: string;

}
